(function (angular) {
  "use strict";

  angular.module('myApp').directive("mainMenu", function () {
    return {
      templateUrl: '/home/views/menu.tpl.html',
      controller: ["$scope", "$attrs", "$rootScope", "flash", function ($scope, $attrs, $rootScope, flash) {
        $rootScope.$watch('permissions', function (newValue, oldValue, scope) {
          $scope.hideMenu = $rootScope.permissions === null;
        });

        $scope.resturant={};
        $scope.openFrontEndLink = function () {
          if (localStorage.getItem("resturant") != null && localStorage.getItem("resturant") != '' && localStorage.getItem("resturant") != undefined){
            $scope.resturant = JSON.parse(localStorage.getItem("resturant"));
          }
          if (localStorage.getItem("isApproved") != null && localStorage.getItem("isApproved") != '' && localStorage.getItem("isApproved") != undefined)
            $scope.isApproved = localStorage.getItem("isApproved");

          if ($scope.isApproved == 'false')
            flash.show("لم تتم الموافقة على طلبكم  بعد", 0);
          else {
            if ($scope.resturant != null)
              window.open('/menu/' + $scope.resturant.encryptedUrl, '_blank');
            else
              flash.show("Resturant not found!", 0);
          }
        }
      }]
    };
  });

}(window.angular));
